import React, { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import get from 'lodash/get';
import classnames from 'classnames';
import Button from '../../Button';
import CollectionsList from '../CollectionList';
import { BiDataHook, BiEventType } from '../../biLogger';
import { getDeviationResourceType } from '../../DeviationViews/_helpers';
import s from './DesktopCollectionPanel.scss';
var DesktopCollectionPanel = function (_a) {
    var selectedFolderCount = _a.selectedFolderCount, selectedFolderIds = _a.selectedFolderIds, collectibleDeviation = _a.collectibleDeviation, errorMsg = _a.errorMsg, isInitialized = _a.isInitialized, _b = _a.collectibleDeviation, author = _b.author, deviationId = _b.deviationId, _c = _a.notificationQueue, notificationQueue = _c === void 0 ? 'default' : _c, initializeDeviation = _a.initializeDeviation, commitCollections = _a.commitCollections, undoChanges = _a.undoChanges, requestClose = _a.requestClose;
    var t = useTranslation().t;
    useEffect(function () {
        initializeDeviation(deviationId, get(collectibleDeviation, 'stats.favourites', 0));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [deviationId, initializeDeviation]);
    var hasError = !!errorMsg;
    return (React.createElement("div", { className: s['root'], "data-hook": BiDataHook.DEVIATION_ADD_TO_FAVES_POPUP },
        React.createElement("div", { className: s['header'] },
            React.createElement("span", { className: s['title'] }, t('collectionPanel.addToFavourites')),
            isInitialized && (React.createElement("span", { className: classnames(s['hint'], hasError && s['error']) }, hasError ? (t('collectionPanel.error.loadFolders')) : (
            // prettier-ignore
            React.createElement(Trans, { i18nKey: "collectionPanel.v2.collectionSelected", count: selectedFolderCount },
                React.createElement("span", { className: s['foldercount'] }, {
                    count: selectedFolderCount
                }),
                " collections selected")))),
            React.createElement("div", { className: s['buttons'] },
                React.createElement(Button, { view: "b31", className: s['cancel'], onClick: function () {
                        undoChanges(deviationId);
                        requestClose();
                    } }, t('common.cancel')),
                React.createElement(Button, { view: "b14", className: s['done'], onClick: function () {
                        commitCollections(collectibleDeviation, notificationQueue);
                        requestClose();
                    }, biData: {
                        evid: BiEventType.ADD_TO_COLLECTION_DONE_CLICK,
                        creatorid: author && author.useridUuid,
                        typeid: getDeviationResourceType(collectibleDeviation),
                        itemid: deviationId,
                        sectionname: undefined,
                        collectionid: selectedFolderCount > 1 ? undefined : selectedFolderIds[0],
                        num_collections: selectedFolderCount,
                    } }, t('common.done')))),
        React.createElement(CollectionsList, { collectibleDeviation: collectibleDeviation })));
};
export default DesktopCollectionPanel;
//# sourceMappingURL=DesktopCollectionPanel.actionbar_phase_2.js.map